import cx from 'classnames';
import * as React from 'react';
import { Badge } from '@dropbox/dig-components/badge';
import { Empty } from './empty';
import { Loading } from './loading';
import { Section } from './section';
import { UtilityActionMenu } from '../utility_action_menu';
import { NotificationLine } from '@dropbox/dig-icons/assets';
import { Menu } from '@dropbox/dig-components/menu';
import { Text } from '@dropbox/dig-components/typography';
/**
 * The Notification menu and contents.
 */
// prettier-ignore
export const NotificationMenu = (props) => {
    const { hasNotifications, title, isLoading, emptyMessage, sections, onToggle, contentClassName, ...rest } = props;
    const isEmpty = !sections ||
        sections.length === 0 ||
        sections.every(s => {
            return !s.items || s.items.length === 0;
        });
    return (React.createElement(UtilityActionMenu, { ...rest, iconSrc: NotificationLine, wrapperActionProps: { onToggle: onToggle }, menuContentProps: { className: cx('dpc-GlobalHeader-Notification', contentClassName) }, tooltipTitle: props.tooltipTitle, customTriggerContents: hasNotifications ? (React.createElement(Badge, { variant: "alert", className: "dpc-GlobalHeader-NotificationBadge" })) : undefined },
        React.createElement(Menu.Segment, { className: "dpc-GlobalHeader-Notification__title" },
            React.createElement(Menu.Row, { interactive: false },
                React.createElement(Text, { isBold: true }, title))),
        React.createElement(Menu.Segment, null, isLoading ? (React.createElement(Loading, null)) : isEmpty ? (React.createElement(Empty, { emptyMessage: emptyMessage })) : (sections.map(s => React.createElement(Section, { key: s.title, ...s }))))));
};
NotificationMenu.displayName = 'NotificationMenu';
